/**
 * Tailwind class strings for the case suppression admin UI (toolbar, filters, modals).
 */

/** Full-width control in add/edit modals (inputs and selects). */
export const integrationModalField =
  'mt-1 block w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500';

/** Pagination prev/next and page number buttons. */
export const integrationPaginationButton =
  'relative inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 disabled:opacity-50';

/** Search input with room for a left icon (use inside a relative wrapper). */
export const integrationSearchInputBlock =
  'block w-full rounded-md border border-gray-300 bg-white py-2 pl-9 pr-3 text-sm text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500';

/** Same as search block; alias for pages that name it "SearchInput". */
export const integrationSearchInput = integrationSearchInputBlock;

/** Compact text filter (no leading icon). */
export const integrationTextInput =
  'block rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500';

/** Secondary / outline button (toolbar export, modal cancel). */
export const integrationSecondaryButton =
  'inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2';

/** Native select in filter rows. */
export const integrationSelect =
  'block rounded-md border border-gray-300 bg-white py-2 pl-3 pr-8 text-sm text-gray-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500';

/** Primary action in filter toolbars (Search, Add). */
export const integrationToolbarPrimaryButton =
  'inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50';
